var App = App || {};

App.ComponentInvestingBoxes = (function ($) {
    'use strict';

    function Init() {
        $(".component-investingBoxes").each(function () {
            const carousel = $(this).find(".component-investingBoxes-carousel");
            Carousel(carousel);
        });
    }

    function Carousel(carousel) {

        const splide = new Splide(carousel.find(".splide")[0], {
            type: "loop",
            perPage: 1
        });

        splide.mount({});
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.ComponentInvestingBoxes.Init();
});